export const SET_APP_SESSION_ID = 'SESSION:SET_APP_SESSION_ID';
export const SET_VIDEO_SESSION_ID = 'SESSION:SET_VIDEO_SESSION_ID';
